export class DataCatalogEffectiveTag {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        },
        {
            "name": "source",
            "baseName": "source",
            "type": "DataCatalogTagSource",
            "format": ""
        },
        {
            "name": "sourceNamespacePath",
            "baseName": "sourceNamespacePath",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "sourceDatasetName",
            "baseName": "sourceDatasetName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogEffectiveTag.attributeTypeMap;
    }
    constructor() {
    }
}
